/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowMoveDown = createReactComponent("outline", "arrow-move-down", "IconArrowMoveDown", [["path", { "d": "M12 11v10", "key": "svg-0" }], ["path", { "d": "M9 18l3 3l3 -3", "key": "svg-1" }], ["path", { "d": "M12 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }]]);

export { IconArrowMoveDown as default };
//# sourceMappingURL=IconArrowMoveDown.mjs.map
